import { PresentationComponentProps, TabsFormComponent } from "../../../index";
import React, { useMemo } from "react";

export const TabsForm = (props: PresentationComponentProps) => {
  const groups = useMemo(() => props.schema.partitionByGroup(), [props.schema]);

  return (
    <TabsFormComponent
      mapper={props.fieldMapper}
      groups={groups}
      data={props.data}
    />
  );
};
